 //判断字母+数字+“_”
function is_ok(str)
{
	exp=/[^0-9a-zA-Z_]/g;
	if(str.search(exp) != -1)
	{
		return false;
	}
	return true;
}
//手机号码检查
export function isMobil(s)
{
	var patrn=/13\d{9}/;
	var patrn2=/15\d{9}/;
	var patrn3=/18\d{9}$/;
	var patrn4=/14\d{9}/;
	var patrn5=/17\d{9}/;
	var patrn6=/16\d{9}/;
	var patrn7=/19\d{9}/;
	if (!patrn.exec(s)&&!patrn2.exec(s)&&!patrn3.exec(s)&&!patrn4.exec(s)&&!patrn5.exec(s)&&!patrn6.exec(s)&&!patrn7.exec(s)){
	  return false
	}
	return true
}
//电话号码检查
export function isphone(s)
{
var partten = /^0(([1,2]\d)|([3-9]\d{2}))\d{8}$/;
if (!partten.exec(s)){
  return false
}
return true
}
 //判断是中文

function is_zw(str)
{
	var exp=/[0-9a-zA-Z_]/g;
	if(str.search(exp) != -1)
	{
		return false;
	}
	return true;
}
 //判断数字
export function is_number(str)
{
	var exp=/[^0-9()-]/g;
	if(str.search(exp) != -1)
	{
		return false;
	}
	return true;
}
 //判断Email
 export function is_email(str)
{ 
	if((str.indexOf("@")==-1)||(str.indexOf(".")==-1))
    {
	return false;
	}
	return true;
}

 //判断SQL
function is_nosql(str)
{ 
	if( (str.indexOf("'")==-1)&&(str.indexOf('"')==-1)&&(str.indexOf(";")==-1)&&(str.indexOf("&")==-1)&&(str.indexOf("|")==-1))
    {
		return true;
    }
    return false;
}

//去除字符串两边空格的函数
//参数：mystr传入的字符串
//返回：字符串mystr
function trim(mystr){
while ((mystr.indexOf(" ")==0) && (mystr.length>1)){
mystr=mystr.substring(1,mystr.length);
}//去除前面空格
while ((mystr.lastIndexOf(" ")==mystr.length-1)&&(mystr.length>1)){
mystr=mystr.substring(0,mystr.length-1);
}//去除后面空格
if (mystr==" "){
mystr="";
}
return mystr;
}


 /**//*以指定的长度得到字符串，余下的以“”代替
参数str是要显示的字符串;strlen是显示的长度,也就是截取的长度
该函数返回一个字符串*/

function cutStr(str,strlen){
 var l,t,c;
 l = str.length;
 t = 0;
 for(i=0;i<l;i++){
 
 c = str.substring(i,i+1); /**//*获取第一个字符，并判断它是字母还是汉字*/
  
  if(is_zw(c)){               /**//*如果是汉字，步长加2*/
   t = t + 2;
  }else{
   t = t + 1;          /**//*如果是字母，步长加1*/
  }
  
  if(t>= strlen){
   return str.substring(0,i+1);
  }
  
 }
 return str;
}



// WEBPACK FOOTER //
// ./src/assets/js/checkFunction.js